"use client";

import { Core } from "@faire/slate/foundation/color";
import Color from "@faire/web/slate/Color";
import { SVGIcon } from "@faire/web/slate/icons/SVGIcon";
import { getEventTheme } from "@faire/web/slate/Theme/eventsThemeColors";
import React from "react";

interface IProps extends SVGIcon.IProps {
  isInverse?: boolean;
  iconColor?: Color;
}

export const MarketSecondaryLogo: React.FC<IProps> = ({
  isInverse,
  iconColor,
  ...rest
}) => {
  const textShapeColor = isInverse
    ? Core.text.primaryInverse
    : getEventTheme("faireMarket").promoText;

  const defaultColor = isInverse
    ? getEventTheme("faireMarket").promoTextInverse
    : getEventTheme("faireMarket").promoText;
  const iconShapeColor = iconColor ?? defaultColor;

  return (
    <SVGIcon
      width="203"
      height="143"
      viewBox="0 0 203 143"
      fill="none"
      {...rest}
    >
      <path
        d="M1.24023 139.006V123.028H6.39404V132.19H11.3024V124.872H16.2108V132.19H24.4078V139.006H1.24023Z"
        fill={textShapeColor}
      />
      <path
        d="M1.24023 106.894V98.3697L24.4078 91.0726V98.0482L20.0983 99.2563V106.885L24.4078 108.102V114.24L1.24023 106.894ZM15.504 105.608V100.552L6.66891 103.066L15.504 105.608Z"
        fill={textShapeColor}
      />
      <path
        d="M4.43579 74.1435L6.38587 67.905L28.4023 74.4487L26.4522 80.6872L4.43579 74.1435Z"
        fill={textShapeColor}
      />
      <path
        d="M14.0223 49.8608L19.2439 42.4512C22.7282 37.5507 26.6836 36.1785 30.6783 38.9914L30.7862 39.06C31.9176 39.7677 32.7831 40.8288 33.2482 42.0784C33.7132 43.328 33.7517 44.696 33.3577 45.9697L44.3799 46.9498L40.3558 52.6638L30.8746 51.6837L29.9814 52.9481L36.7537 57.7212L32.9553 63.1117L14.0223 49.8608ZM27.6847 48.7924C28.9705 46.9597 28.8429 45.5287 27.3019 44.4408L27.194 44.3722C25.6628 43.2941 24.3771 43.8135 23.1502 45.5581L21.8743 47.3321L26.4284 50.537L27.6847 48.7924Z"
        fill={textShapeColor}
      />
      <path
        d="M39.5865 20.8453L52.7487 11.9832L55.5677 16.2046L47.8493 21.4108L50.0463 24.6963L56.1996 20.5528L58.8048 24.4525L52.6515 28.596L54.9748 32.0667L63.1306 26.5779L65.9497 30.7993L52.3404 39.9441L39.5865 20.8453Z"
        fill={textShapeColor}
      />
      <path
        d="M90.2025 0L98.6094 0.135087L102.732 12.3316L107.236 0.279819L115.481 0.405262L115.127 23.1676L108.705 23.0615L108.925 8.89652L103.199 22.9746H101.052L95.8326 8.72282L95.6417 22.8588L89.9163 22.7623L90.2025 0Z"
        fill={textShapeColor}
      />
      <path
        d="M142.062 7.98883L149.832 11.7972L146.18 35.9497L139.825 32.832L140.627 28.4021L133.698 24.9982L130.669 28.3429L125.067 25.6001L142.062 7.98883ZM136.886 21.4562L141.488 23.7057L143.161 14.5499L136.886 21.4562Z"
        fill={textShapeColor}
      />
      <path
        d="M171.028 27.162L176.965 33.8266C180.937 38.2729 181.317 42.3447 177.676 45.5041L177.579 45.5905C176.631 46.5048 175.403 47.0851 174.087 47.2414C172.77 47.3976 171.438 47.1211 170.297 46.4548L166.793 56.7206L162.208 51.6213L165.304 42.8056L164.33 41.6628L158.159 47.0214L153.827 42.2198L171.028 27.162ZM168.896 40.4144C170.356 42.0566 171.816 42.2582 173.179 41.0386L173.276 40.9618C174.678 39.7422 174.464 38.4073 173.062 36.8324L171.641 35.2383L167.474 38.8395L168.896 40.4144Z"
        fill={textShapeColor}
      />
      <path
        d="M193.429 58.3185L195.621 64.5806L186.903 67.5023L197.901 71.0765L200.162 77.5822L187.16 73.0925L178.274 85.4805L175.766 78.2834L182.796 68.895L173.594 72.0212L171.402 65.7591L193.429 58.3185Z"
        fill={textShapeColor}
      />
      <path
        d="M201.76 95.866V112.114H196.635V102.575H192.65V110.18H187.928V102.575H183.707V112.643H178.592V95.866H201.76Z"
        fill={textShapeColor}
      />
      <path
        d="M196.635 129.697V123.827H201.76V142.201H196.635V136.292H178.592V129.716L196.635 129.697Z"
        fill={textShapeColor}
      />
      <path
        d="M144.24 96.6981H114.501L140.085 81.5366L136.455 75.4155L111.514 90.1878L126.14 65.1587L119.99 61.5678L105.062 87.1127V57.5195H97.9383V87.2586L82.7768 61.6748L76.646 65.3046L91.428 90.2462L66.3989 75.6199L62.7983 81.7701L88.3432 96.6981H58.7598V103.821H88.4989L62.9151 118.983L66.5449 125.114L91.4864 110.332L76.8601 135.361L83.0104 138.961L97.9383 113.417V143H105.062V113.261L120.223 138.845L126.344 135.215L111.572 110.273L136.601 124.9L140.192 118.749L114.647 103.821H144.24V96.6981Z"
        fill={iconShapeColor}
      />
    </SVGIcon>
  );
};
